module.exports = __webpack_public_path__ + "static/media/ai_blur_logo.ebb0d458.svg";